module.exports = __webpack_public_path__ + "images/stickers/residue.98ba01532da369b380d1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/residue.png
// module id = tVOG
// module chunks = 12